/** @type {React.ComponentType} */
export default function SummaryIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 10H17.5M2.5 5H8.33333M2.5 15H17.5"
        stroke="#ffffff"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9274 4.625C11.7712 4.68403 11.667 4.83333 11.667 5C11.667 5.16666 11.7712 5.31597 11.9274 5.375L13.8892 6.11111L14.6253 8.07291C14.6844 8.22916 14.8337 8.33333 15.0003 8.33333C15.167 8.33333 15.3163 8.22916 15.3753 8.07291L16.1114 6.11111L18.0732 5.375C18.2295 5.31597 18.3337 5.16666 18.3337 5C18.3337 4.83333 18.2295 4.68403 18.0732 4.625L16.1114 3.88889L15.3753 1.92708C15.3163 1.77083 15.167 1.66666 15.0003 1.66666C14.8337 1.66666 14.6844 1.77083 14.6253 1.92708L13.8892 3.88889L11.9274 4.625Z"
        fill="#ffffff"
      />
    </svg>
  );
}
